import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.div`
  padding: 15px;
  width: 100%;
`;

export const Row = styled.div`
  flex-direction: row;
  margin-bottom: 15px;
`;
